import React, { memo, useMemo, useState, useCallback, useEffect } from 'react';
import { CUSTOM_MESSAGES, LABEL } from '@veriables';
import cn from 'classnames';
import { sort } from '@utility/helperFunction';
import style from './moveItemModal.module.scss';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import {
    addChecks,
    setHighlightCartItems,
    replaceCart,
    getUpdatedCart,
    moveChecks,
    updateCartAfterNote,
    changeCheckOrdersTab,
} from '@reducers/orders';
import {
    updateChecksAfterResponse
} from '@reducers/storeChecks';
import {
    setErrorPopUp,
} from '@reducers/notification';
import { addInProcessItemsToCart } from '../../../MenuOrderHandler';
import CustomEventEmitter from '@utility/customEventEmitter';
import { safeJsonParse } from '@utility/helperFunction';


const MoveItemModal = ({ isOpen, data, closeModal, ...props }) => {
    const {
        serverAppTheme,
        isOrderingPortrait,
        isLandScape,
        seat,
        menuItemsHashTable,
        deviceInfo,
        userInfo,
        cart,
        addChecks,
        setHighlightCartItems,
        replaceCart,
        updateChecksAfterResponse,
        setErrorPopUp,
        isPendingList,
        moveChecks,
        changeCheckOrdersTab,
    } = props; // Redux imports
    const [selectedSeats, setSelectedSeats] = useState([]);

    useEffect(() => {
        if (isOpen) {
            setSelectedSeats([]);
        }
    }, [isOpen]);


    const isTab = seat?.tab;

    const actionModal = useMemo(() => {
        const fullWidthModal = {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            pointerEvents: 'auto',
            backgroundColor: serverAppTheme?.popUp_bg,
            backgroundClip: 'padding-box',
            height: '100%',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
        };
        const parentContainer = { color: serverAppTheme?.primary_text };
        const buttonContainer = {
            padding: '4px 60px 0px',
            alignItems: 'baseline',
        };
        const tableStyle = {
            width: '300px',
            height: '44px',
            color: selectedSeats.includes('table')
                ? '#000'
                : serverAppTheme?.primary_text,
            border: serverAppTheme?.popupBorder,
            background: selectedSeats.includes('table')
                ? serverAppTheme?.selected
                : serverAppTheme?.OFF_Premise_Btn,
        };
        const cancelButton = {
            backgroundColor: serverAppTheme?.OFF_Premise_Btn,
            border: serverAppTheme?.cancleBtn_Border,
            color: serverAppTheme?.cancleBtn_font,
            borderRadius: '8px',
        };
        const moveButton = {
            backgroundColor: serverAppTheme?.secondaryBtn,
            color: serverAppTheme?.btn_font_color,
            borderRadius: '8px',
        };

        return {
            fullWidthModal,
            parentContainer,
            buttonContainer,
            tableStyle,
            cancelButton,
            moveButton,
            isOrderingPortrait
        };
    }, [serverAppTheme, isLandScape, selectedSeats]);

    const getGiftAndGameCard = () => {
        let arr = [];
        for (let ind = 0; ind < data.length; ind++) {
            arr.push(menuItemsHashTable[data[ind].menuItemId]?.cardType);
            if (
                !data[ind].isLinked &&
                data[ind].uniqueIdForLinkedItem
            ) {
                let value = seat.orders[0].items;
                for (let index = 0; index < value.length; index++) {
                    const element = value[index];
                    let orderjson = safeJsonParse(element?.orderJson, {});
                    if (orderjson.isLinked) {
                        if (
                            data[ind]?.uniqueIdForLinkedItem ===
                            orderjson?.uniqueIdForLinkedItem
                        ) {
                            arr.push(menuItemsHashTable[orderjson.menuItemId]?.cardType);
                        }
                    }
                }
            }
        }
        return arr.includes(2) || arr.includes(1);
    };

    const addRemoveSeats = node => {
        if (selectedSeats.indexOf(node) === -1 && selectedSeats.includes('table')) {
            setSelectedSeats([node]);
        } else if (
            selectedSeats.indexOf(node) === -1 &&
            !selectedSeats.includes('table')
        ) {
            if (getGiftAndGameCard()) {
                let a = [];
                a[0] = node;
                setSelectedSeats(a);
            } else {
                setSelectedSeats(selectedSeats.concat(node));
            }
        } else {
            setSelectedSeats(selectedSeats.filter(x => x !== node));
        }
        if (node === 'table') {
            setSelectedSeats(['table']);
        }
    };

    const moveSentListItems = ({ dataToSend, seatId }) => {
        const checkItemSeats = (data || [])
            .filter(i => !i.isServiceCharge && !i.isDiscount && !i.discountId && !i.serviceChargeId)
            .map(item => ({ checkItemId: item.id }));
        const checkDiscountSeats = (data || [])
            .filter(i => i.isDiscount || i.discountId || (i.discountName && !i.menuItemId))
            .map(item => {
                const discountId = item.checkDiscountId || (typeof item.id === 'number' ? item.id : Number(String(item.id).replace(/^discount-/, '')));
                return { checkDiscountId: isNaN(discountId) ? item.id : discountId };
            });
        const checkServiceChargeSeats = (data || [])
            .filter(i => i.isServiceCharge || i.serviceChargeId || (i.serviceChargeName && !i.menuItemId))
            .map(item => {
                const serviceChargeId = item.checkServiceChargeId || (typeof item.id === 'number' ? item.id : Number(String(item.id).replace(/^serviceCharge-/, '')));
                return { checkServiceChargeId: isNaN(serviceChargeId) ? item.id : serviceChargeId };
            });

        dataToSend = {
            ...dataToSend,
            seatIds: seatId,
            checkItemSeats,
            checkDiscountSeats,
            checkServiceChargeSeats,
        };

        moveChecks(dataToSend)
            .then(res => {
                updateChecksAfterResponse(res);
                const updatedCart = cart.reduce((a, v) => {
                    const foundIndex = data.findIndex(e => e.id === v.id);
                    if (foundIndex !== -1) {
                        a.push({
                            ...v,
                            seatIds: seatId,
                        });
                    } else {
                        a.push({
                            ...v,
                        });
                    }
                    return a;
                }, []);
                CustomEventEmitter.dispatchEvent('getCartItems', updatedCart);
                updateCartAfterNote(updatedCart);
            })
            .catch(err => {
                setErrorPopUp({
                    res: err.message,
                });
            });
    }

    const movePendingListItem = ({ dataToSend, seatId }) => {
        const cb = () => {
            // Read from sessionStorage to get the live, up-to-date cart
            // (mirrors the local addInProcessItemsToCart in ordersCart.jsx)
            const liveCart = safeJsonParse(window.sessionStorage.getItem('cart'), []);
            const requiredCart = [];
            (data || []).forEach(item => {
                if (item.hasLinkedMenuItem) {
                    const linkedItems = liveCart.filter(
                        e =>
                            e.isLinked &&
                            e.uniqueIdForLinkedItem &&
                            e.uniqueIdForLinkedItem === item.uniqueIdForLinkedItem
                    );
                    linkedItems.forEach(i => {
                        requiredCart.push({
                            ...i,
                            seatIds: seatId,
                            checkOrderItemId: i.id,
                            modifierJson: JSON.stringify({
                                ...i,
                                seatIds: seatId,
                                checkOrderItemId: i.id,
                            }),
                        });
                    });
                }
                const Item = liveCart.find(i => i.internalId === item.internalId);
                if (!Item) return; // guard: skip if item not found in cart
                requiredCart.push({
                    ...Item,
                    checkOrderItemId: Item.id,
                    seatIds: seatId,
                    modifierJson: JSON.stringify({
                        ...Item,
                        checkOrderItemId: Item.id,
                        seatIds: seatId,
                    }),
                });
            });
            dataToSend = {
                ...dataToSend,
                checkHeaderId: seat?.id,
                items: requiredCart,
                orderJson: JSON.stringify(requiredCart),
                longitude: '0',
                latitude: '0',
                geoLocation: '0',
            };
            addChecks(dataToSend, 'update')
                .then(res => {
                    updateChecksAfterResponse(res);
                    const ItemsArray = res.orders[0]?.items || [];
                    const CartItems = [];
                    ItemsArray.forEach(item => {
                        if (item.pending && item.itemType !== 'D') {
                            const cartData = {
                                ...safeJsonParse(safeJsonParse(item?.orderJson, {})?.modifierJson, {}),
                                isProcessing: false,
                                modifierJson: safeJsonParse(item?.orderJson, {})?.modifierJson,
                                id: item.id,
                                checkItemId: item.checkItemId,
                            };
                            CartItems.push(cartData);
                        }
                    });
                    replaceCart(CartItems);
                    const updatedCart = getUpdatedCart();
                    CustomEventEmitter.dispatchEvent('getCartItems', updatedCart);
                    // Switch to sent tab — moved items are now sent, pending list may be empty
                    changeCheckOrdersTab({ isPendingList: false });
                })
                .catch(err => {
                    setErrorPopUp({
                        res: err.message,
                    });
                });
        };
        addInProcessItemsToCart(cb, cart);
    }

    const moveItems = useCallback(
        () => {
            let seatId;
            if (selectedSeats?.includes('table')) {
                seatId = [];
            } else {
                seatId = [];
                selectedSeats?.forEach(e => {
                    seat?.seats.forEach(d => {
                        if (d.open && e === d.number) {
                            seatId.push(d.id);
                        }
                    });
                });
            }
            let dataToSend = {
                storeId: deviceInfo?.storeId,
                deviceId: deviceInfo?.deviceId,
                employeeId: userInfo?.id && Number(userInfo?.id),
                employeeCard: userInfo?.employeeCard,
                checkHeaderId: seat?.id,
                stationId: seat?.stationId,
            };
            setHighlightCartItems([]);

            if (isPendingList) movePendingListItem({ dataToSend, seatId });
            else moveSentListItems({ dataToSend, seatId });

            closeModal();
        },
        [seat, deviceInfo, userInfo, cart, selectedSeats, data]
    );
    return (
        <FullWithModal
            isOpen={isOpen}
            isModalCenter
            style={actionModal.fullWidthModal}
            customClass={'h-100 w-100'}
            customClass2={'h-100 w-100'}
            noBackground
        >
            <div
                className="col-12 w-100 px-0 h-100 justify-content-center align-items-center position-relative text-center "
                style={actionModal.parentContainer}
            >
                <div
                    className={cn(
                        'col-12 px-2 text-center d-flex justify-content-between',
                        style.moretitlebg
                    )}
                >
                    <div>
                        {isTab ? LABEL().TAB : LABEL().TABLE} : {seat?.stationName}
                    </div>
                    <div>{LABEL().MOVE}</div>
                    <div>#{seat?.number}</div>
                </div>
                <div className={cn("text-center fw-600 pt-3", isOrderingPortrait ? 'fs_18' : 'fs_16')}>
                    {<span>{CUSTOM_MESSAGES().SELECT_SEAT_MOVE}</span>}
                </div>

                <div
                    className={cn(
                        isLandScape
                            ? 'd-flex flex-column  fs_12 justify-content-start h-70 mt-2'
                            : 'd-flex flex-column fs-12 justify-content-start h-88 mt-3 px-0'
                        ,
                    )}
                    style={actionModal.buttonContainer}
                >
                    <div className="d-flex align-self-left row mx-0 mb-3">
                        <TouchableButton
                            role="presentation"
                            className={cn(
                                selectedSeats.includes('table')
                                    ? style.selected_cartType
                                    : style.tabletilebackground,
                                style.border_btnTable,
                                'rounded color-white px-3 py-1 text-center d-flex justify-content-center align-items-center', isOrderingPortrait ? 'fs_20' : 'fs_18'
                            )}
                            onClick={() => addRemoveSeats('table')}
                            disabled={getGiftAndGameCard()}
                            style={actionModal.tableStyle}
                        >
                            {isTab ? LABEL().TAB : LABEL().TABLE}
                        </TouchableButton>
                    </div>
                    <div
                        className={cn(
                            'overflowY align-items-center w-100',
                            isLandScape ? style.wrapperMove : style.wrapperMoveP
                        )}
                    >
                        {seat?.seats?.length > 0 &&
                            sort(seat.seats, 'number').map(item => {
                                return (
                                    <>
                                        {item.open && (
                                            <TouchableDiv
                                                role="presentation"
                                                key={item.number}
                                                onClick={() => addRemoveSeats(item.number)}
                                                className={cn(
                                                    selectedSeats.length > 0 &&
                                                        selectedSeats.includes(item.number)
                                                        ? `${style.selectedNum} `
                                                        : `${style.unSelectedNum}`,
                                                    'w-100 rounded text-center fs_20 fw-600 flex-column py-1 px-2 d-flex justify-content-center align-items-center mx-0'
                                                )}
                                                style={{
                                                    width: isLandScape ? '90px' : '100%',
                                                    height: '85px',
                                                    color: selectedSeats.includes(item.number)
                                                        ? '#000'
                                                        : serverAppTheme?.primary_text,
                                                    border: selectedSeats.includes(item.number)
                                                        ? 'none'
                                                        : serverAppTheme?.popupBorder,
                                                    background: selectedSeats.includes(item.number)
                                                        ? serverAppTheme?.selected
                                                        : serverAppTheme?.unselected,
                                                }}
                                            >
                                                <div>{item.number} </div>
                                                {item.name ? (
                                                    <div className={style.truncate}>
                                                        {`${item?.name.substring(0, 5)}...`}
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </TouchableDiv>
                                        )}
                                    </>
                                );
                            })}
                    </div>
                </div>
                <div
                    className={
                        isOrderingPortrait
                            ? `col-12 row mx-0 justify-content-center align-items-center position-absolute text-center w-100 pb-3 pt-3 ${style.paddingRL}`
                            : 'col-12 row mx-0 px-0 mt-2 justify-content-center align-items-center position-relative text-center w-100'
                    }
                    style={{ bottom: isOrderingPortrait ? 0 : '8px' }}
                >
                    <div
                        className={cn(
                            isOrderingPortrait
                                ? 'col-6 pr-1'
                                : 'w-45 pl-0 pr-1'
                        )}
                    >
                        <TouchableButton
                            type="submit"
                            className={cn(style.btnSecondaryMove, 'col-12 px-0 btn44',)}
                            onClick={e => {
                                e.stopPropagation();
                                e.preventDefault();
                                closeModal()
                            }}
                            style={actionModal.cancelButton}
                            rippleEffect={true}
                        >
                            <div className="fw-600">{LABEL().CANCEL}</div>
                        </TouchableButton>
                    </div>
                    <div
                        className={cn(
                            isOrderingPortrait
                                ? 'col-6 pl-1'
                                : 'w-45 pr-0 pl-1'
                        )}
                    >
                        <TouchableButton
                            type="submit"
                            className={cn('col-12 px-0 btn44')}
                            onClick={() => {
                                if (selectedSeats.length === 0) {
                                    setErrorPopUp({
                                        res: CUSTOM_MESSAGES().SM_SELECT_SEAT_MOVE_ERROR,
                                        noErrorTxt: true,
                                    });
                                } else {
                                    moveItems();
                                }
                            }}
                            style={actionModal.moveButton}
                            rippleEffect={true}
                        >
                            <div className="fw-600">{LABEL().MOVE}</div>
                        </TouchableButton>
                    </div>
                </div>
            </div>
        </FullWithModal>
    )
}

const mapStateToProps = ({ theme, orders, oauth }) => ({
    serverAppTheme: theme.serverAppTheme,
    seat: orders.seats,
    menuItemsHashTable: orders.menuItemsHashTable,
    isLandScape: true, // TODO: Needs to use respecitve key
    isOrderingPortrait: true, // TODO: Needs to use respecitve key
    deviceInfo: oauth.deviceInformation,
    userInfo: oauth.loggedInUserData,
    cart: orders.cart,
    isPendingList: orders.isPendingList,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setHighlightCartItems,
    addChecks,
    updateChecksAfterResponse,
    replaceCart,
    setErrorPopUp,
    moveChecks,
    updateCartAfterNote,
    changeCheckOrdersTab,
}, dispatch)

const MemoizedMoveItemModal = memo(MoveItemModal);

export default connect(mapStateToProps, mapDispatchToProps)(MemoizedMoveItemModal);
